import { render } from "./ScienceShow.vue?vue&type=template&id=29c0058c&scoped=true"
import script from "./ScienceShow.vue?vue&type=script&lang=js"
export * from "./ScienceShow.vue?vue&type=script&lang=js"

import "./ScienceShow.vue?vue&type=style&index=0&id=29c0058c&lang=scss&scoped=true"

import exportComponent from "E:\\uni-app项目\\kxsns-master\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29c0058c"]])

export default __exports__